export default __webpack_public_path__ + "static/media/Reports-Illustration-2.6a5b9e83.png";